var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import Hotdeal from './hotdeal';
import PriceTokArea from './price_tok';
import ProductDetailInfo from './product_detail_info';
import ProductSide from './product_side';
import PriceOptionAdded from './price_option_added';
import LowButtons from './low_button';
import PriceTokNotMiniShop from './notminishop/price_tok_not_minishop';
var SummaryInfoDetail = function () {
    var userInfo = useSelector(function (state) { return state.common.userInfo; });
    var item = useSelector(function (state) { return state.product.item; });
    var stdpcOptionLoaded = useSelector(function (state) { return state.product.stdpcOptionLoaded; });
    var minishop = item === null || item === void 0 ? void 0 : item.minishop;
    var isHotdeal = (item === null || item === void 0 ? void 0 : item.hot_deal) ? true : false;
    var isStdpc = (item === null || item === void 0 ? void 0 : item.cate_id.toString().slice(0, 1)) === '2';
    return (React.createElement(React.Fragment, null, item && minishop ? (React.createElement(Style, null,
        isHotdeal && React.createElement(Hotdeal, { data: item.hot_deal }),
        React.createElement(PriceTokArea //가격
        , { hotdealData: item.hot_deal, minishop: minishop, item_id: item.item_id, userInfo: userInfo, isStdpc: isStdpc }),
        // stdpcOptionLoaded ?
        isStdpc && React.createElement(ProductDetailInfo, null) //상품정보
    // : <Loading2/>
    ,
        React.createElement(ProductSide, { minishop: minishop }),
        // stdpcOptionLoaded ?
        isStdpc && React.createElement(PriceOptionAdded, null)
    // : <Loading2/>
    ,
        React.createElement(LowButtons, { idx_b_manager: minishop.idx_b_manager, item_id: item.item_id, userInfo: userInfo, isStdpc: isStdpc }))) : (item && (React.createElement(Style, null,
        React.createElement(PriceTokNotMiniShop, { hotdealData: item.hot_deal, item_id: item.item_id, userInfo: userInfo }),
        isStdpc && React.createElement(ProductDetailInfo, null))))));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 430px;\n    margin: 0 0 0 20px;\n"], ["\n    width: 430px;\n    margin: 0 0 0 20px;\n"])));
export default SummaryInfoDetail;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/summary_info/detail/index.tsx
// module id = 205
// module chunks = 0